import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import * as moment from 'moment';
import { DriverAssignementService } from 'src/app/frontoffice/driverassignment/driverassignment.service';
import { OrderService } from '../../../order.service';
import { FormContainerModel } from 'projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model';

@Component({
  selector: 'order-driverassignmentfastaccess',
  templateUrl: './driverassignmentfastaccess.component.html',
  styleUrls: ['./driverassignmentfastaccess.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DriverAssignementService]
})

export class DriverAssignmentFastAccessComponent {
  constructor(public driverservice: DriverAssignementService, public order: OrderService, public cd: ChangeDetectorRef,__id: FormContainerModel) {
    this.driverservice.isFastAccess = true;
     const m = moment();
      this.driverservice.GetAllInvoicesByDate(m.locale('fa').format('YYYY/MM/DD'));
    this.order.cd_FastAccessDriverAssignment = cd;
    this.driverservice._id = __id.metadata.id;
    this.driverservice.inputSearch = 'searchInput'+ __id.metadata.id;
    this.driverservice.inputBarCode = 'barcodeInput'+__id.metadata.id;
    this.driverservice.setFormGroupValue();
  }

  async ngOnInit() {
    setTimeout(() => {
      this.driverservice.focus();
    }, 500);
  }
}
